import React, { type JSX } from 'react';
import { Query } from '@apollo/client/react/components';
import query from './AvailableSumCategoriesQuery.gql';
import { KodplanConsumer } from '../../../../../../../../../Components/KodplanManager/Context/KodplanContext';
import {
  AvailableSumCategoriesQuery as AvailableSumCategoriesQueryData,
  AvailableSumCategoriesQueryVariables,
} from './_QueryTypes/AvailableSumCategoriesQuery';
import { ApolloError } from '@apollo/client';
import { ISumCategory } from '../../../../Queries/EkonomiskAnalysSettingsQuery/EkonomiskAnalysSettingsQuery';
import { notNullOrUndefined } from '../../../../../../../../../Utils/utils';

interface IChildrenProps {
  loading: boolean;
  error?: ApolloError | Error;
  availableCategories?: ISumCategory[];
}

interface IProps {
  children: (childrenProps: IChildrenProps) => JSX.Element | null;
}

const AvailableSumCategoriesQuery: React.FunctionComponent<IProps> = props => {
  return (
    <KodplanConsumer>
      {({ activeKodplan }) => {
        const kodplanId = activeKodplan ? activeKodplan.id : undefined;
        return (
          <Query<
            AvailableSumCategoriesQueryData,
            AvailableSumCategoriesQueryVariables
          >
            query={query}
            variables={{ codeSystemId: kodplanId || '' }}
            skip={!kodplanId}
          >
            {({ loading, data, error }) => {
              if (loading || error) {
                return props.children({ loading, error });
              } else if (!data || !data.ekanalysstandardsumcategories) {
                return props.children({
                  loading: false,
                  error: new Error('Could not get sum categories'),
                });
              } else {
                const availableCategories = data.ekanalysstandardsumcategories
                  .filter(notNullOrUndefined)
                  .map(x => {
                    return {
                      name: x.name || 'NAMN SAKNAS',
                      code: x.code,
                      subCategories: x.categories
                        ? x.categories
                            .filter(notNullOrUndefined)
                            .map(category => {
                              return {
                                name: category.name,
                                code: category.code,
                                sums: category.sums
                                  ? category.sums
                                      .filter(notNullOrUndefined)
                                      .map(sum => {
                                        return {
                                          LOPNR: sum.LOPNR,
                                          Namn: sum.Namn,
                                          ORDNINGS_NR_KONTODEL:
                                            sum.ORDNINGS_NR_KONTODEL,
                                          STARTPOS: sum.STARTPOS,
                                          SLUTPOS: sum.SLUTPOS,
                                          GRUPPERINGSTYP: sum.GRUPPERINGSTYP,
                                          DOLJ_NIVA: sum.DOLJ_NIVA,
                                          SIDBRYTNING: sum.SIDBRYTNING,
                                          BENAMNING_FLERA_RADER:
                                            sum.BENAMNING_FLERA_RADER,
                                          BENAMNING_BLANK: sum.BENAMNING_BLANK,
                                          DELSUMMA: sum.DELSUMMA,
                                          SKRIV_DELSUMMA: sum.SKRIV_DELSUMMA,
                                          Typ: sum.Typ,
                                          attributename: sum.attributename,
                                        };
                                      })
                                  : [],
                              };
                            })
                        : [],
                    };
                  });
                return props.children({ loading: false, availableCategories });
              }
            }}
          </Query>
        );
      }}
    </KodplanConsumer>
  );
};

export default AvailableSumCategoriesQuery;
